module.exports = __webpack_public_path__ + "img/winwin_zw.cc773bba.jpg";